import GlobalLoader from '@/components/feature/GlobalLoader';

interface PlayerLoadingProps {
  text?: string;
}

export default function PlayerLoading({ text = 'Loading player...' }: PlayerLoadingProps) {
  return (
    <div className="flex items-center justify-center min-h-screen bg-neutral-950">
      <GlobalLoader size="lg" text={text} />
    </div>
  );
}